import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  rollOutMarketList: {},
  isLoading: false,
  error: "",
  hasData: false,
  rollOutMarketStatus: {
    status: false,
    message: ""
  }
};
const rollOutMarketListSlice = createSlice({
  name: "rolloutMarket",
  initialState,
  reducers: {
    rollOutListRequest: state => {
      state.isLoading = true;
    },
    rollOutListSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.rollOutMarketList = action.payload;
      state.rollOutMarketStatus = true;
    },
    rollOutListFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.rollOutMarketStatus = false;
    }
  }
});
export const {
  rollOutListRequest,
  rollOutListSuccess,
  rollOutListFailure
} = rollOutMarketListSlice.actions;
export default rollOutMarketListSlice.reducer;